// extracted by mini-css-extract-plugin
module.exports = {"PhotoTitleEditForm__submitBtn":"iu_a bhc_rm","PhotoTitleEditForm__cancelBtn":"iu_b bhc_rq bhc_rp"};